import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { chatApi } from "./api";
import { ForkCard } from "./ForkCard";
import { AccessCard } from "./cards/AccessCard";
import { UI, useLang } from "./lang";
import { Loading } from "./Loading";

/**
 * The decisions that are mine (NEW-UX-2), as the same cards the thread pins;
 * for a Supervisor, the access requests waiting on them too (agent-library
 * Task 8), as the access cards their thread shows.
 */
export function Queue() {
  const { workspaceId = "" } = useParams<{ workspaceId: string }>();
  const { t } = useLang();
  const q = useQuery({ queryKey: ["chat-queue", workspaceId], queryFn: () => chatApi.queue(workspaceId), enabled: !!workspaceId ,
    // "Trying again" is true: while the server is unreachable, ask every 5 s.
    refetchInterval: (query) => (query.state.status === "error" ? 5000 : false),
  });
  if (!q.data) return <Loading q={q} />;
  // A rewrite is decided on the card of the ad it replaces, never on its own.
  const open = q.data.forks.filter((f) => !f.resolution && f.hand_key !== "h06_rewrite");
  const access = q.data.access ?? [];
  if (open.length === 0 && access.length === 0) return <div className="pwa-empty">{t(UI.nothingWaiting)}</div>;
  return (
    <div className="pwa-list">
      {open.map((f) => (
        <ForkCard key={f.run_id} fork={f} run={q.data.runs?.[f.run_id] ?? null} workspaceId={workspaceId} />
      ))}
      {access.map((c) => (
        <AccessCard key={c.request_id} card={c} workspaceId={workspaceId} />
      ))}
    </div>
  );
}
